"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AffiliateProgramFeatureUtils = void 0;
const enums_1 = require("../enums");
class AffiliateProgramFeatureUtils {
    constructor(enabledFeaturesList) {
        this.forbiddingFeatures = [enums_1.AffiliateProgramFeature.Off];
        this.enabledFeatures = Array.from(new Set(enabledFeaturesList.replace(/\s/g, '').split(','))).map((value) => value);
    }
    isRegisterWithCodeEnabled() {
        return this.isEnabled([enums_1.AffiliateProgramFeature.RegisterWithCode]);
    }
    isRegistrationRewardEnabled() {
        return this.isEnabled([enums_1.AffiliateProgramFeature.RegisterWithCode, enums_1.AffiliateProgramFeature.RegistrationReward]);
    }
    isJoinTournamentEnabled() {
        return this.isEnabled([enums_1.AffiliateProgramFeature.JoinTournament]);
    }
    isWithdrawTournamentEnabled() {
        return this.isEnabled([enums_1.AffiliateProgramFeature.WithdrawTournament]);
    }
    isCommissionPayoutEnabled() {
        return this.isEnabled([enums_1.AffiliateProgramFeature.CommissionPayout]);
    }
    isShortUrlEnabled() {
        return this.isEnabled([enums_1.AffiliateProgramFeature.ShortUrl]);
    }
    isAffiliateProgramOwnerViewEnabled() {
        return this.isEnabled([enums_1.AffiliateProgramFeature.OwnerView]);
    }
    isEnabled(features) {
        if (this.isAllDisabled()) {
            return false;
        }
        return features.every((feature) => this.enabledFeatures.includes(feature));
    }
    isAllDisabled() {
        if (!this.enabledFeatures.length)
            return false;
        return this.enabledFeatures.some((feature) => this.forbiddingFeatures.includes(feature));
    }
}
exports.AffiliateProgramFeatureUtils = AffiliateProgramFeatureUtils;
//# sourceMappingURL=affiliate-program-feature-utils.js.map